import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FunctionComponent } from 'react';

type ReplaceArrowsProps = {
    className?: string;
};

const ReplaceArrows: FunctionComponent<ReplaceArrowsProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'replace-arrows'}
            viewBox="0 0 250 250"
        >
            <path d="M206.9 215.1H84.7c-11.6 0-22.4-4.5-30.6-12.7-8.1-8.2-12.6-19.1-12.5-30.7l.6-63.9 9 .1-.6 63.9c-.1 9.1 3.4 17.7 9.9 24.2 6.4 6.5 15 10.1 24.2 10.1H207v9z" />
            <polygon points="87.3,150 46.5,109.6 6.9,149.2 0.6,142.9 46.5,96.9 93.6,143.6" />
            <g>
                <path d="M206.6 160.7l-9-.1.6-63.9c.1-9.1-3.4-17.7-9.9-24.2-6.4-6.5-15-10.1-24.2-10.1H41.9v-9h122.3c11.6 0 22.4 4.5 30.6 12.7 8.1 8.2 12.6 19.1 12.5 30.7l-.7 63.9z" />
                <polygon points="202.4,171.7 155.3,125 161.6,118.6 202.4,159 241.9,119.4 248.3,125.8" />
            </g>
        </svg>
    );
};

export default ReplaceArrows;
